import React from "react"
import PropTypes from "prop-types"
import clsx from "clsx"
import { useStaticQuery, graphql } from "gatsby"
import { stripPrefix } from "~utils/path"

import * as styles from "./fluid-image.module.css"

const gql = graphql`
  query {
    images: allFile(filter: { extension: { regex: "/(jpe?g|png|svg|gif)/" } }) {
      nodes {
        relativePath
        publicURL
      }
    }
  }
`

const FluidImage = (props) => {
  const relativePath = stripPrefix(props.relativePath)
  const image = useStaticQuery(gql).images.nodes.find((i) => i.relativePath === relativePath.replace(/^\//, ""))

  const imageProps = {
    alt: props.alt,
    width: props.width,
    height: props.height,
    className: clsx(styles.fluidImage, {
      [styles.precomposed]: relativePath.match(/-precomposed/i) || props.precomposed,
    }),
  }

  if (relativePath.startsWith("http")) {
    imageProps.src = relativePath
  } else if (image) {
    imageProps.src = image.publicURL
  } else {
    console.warn("Unable to find image", relativePath)
    return null
  }

  const match = relativePath.match(/-(\d+)[wh]\./i)
  if (match) {
    const dimension = match[0].indexOf("w") > 0 ? "width" : "height"
    const size = match[1]

    imageProps[dimension] = size
  }

  return <img {...imageProps} /> // eslint-disable-line jsx-a11y/alt-text
}

FluidImage.defaultProps = {
  alt: "",
}

FluidImage.propTypes = {
  alt: PropTypes.string,
  relativePath: PropTypes.string.isRequired,
}

export default FluidImage
